/**
 * @Author: DJ
 * @Date:   2021-09-04 10:46:24
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-07 11:13:40
 */
import { createModel } from '@/store/tools';

const model = {
    namespace: 'microbusinessesstatements',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getStateList': T('getStateList'), // 状态
            'getTableSource': T('getTableSource'), // 对账明细列表
            'getDetail': T('getDetail'), // 详情
            'getQueryReconciliations': T('getQueryReconciliations'), // 列表
            'getOpearationList': T('getOpearationList'), // 运营公司列表
            'getSmallTransportReconMisService':T('getSmallTransportReconMisService'), // 小运力公司-对账单列表
        },
        actions: {
            'getStateList': A('getStateList'),
            'getTableSource': A('getTableSource'),
            'getDetail': A('getDetail'),
            'getQueryReconciliations': A('getQueryReconciliations'),
            'getOpearationList': A('getOpearationList'),
            'getSmallTransportReconMisService': A('getSmallTransportReconMisService'),
        },
        sagas: {
            'getStateList': S('getStateList', '/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReconService.getReconStatus'),
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.reconciliation.SmallTransportReconMisService.listItems'),
            'getDetail': S('getDetail', '/?cmd=com.xqxc.api.pig.mis.reconciliation.SmallTransportReconMisService.detail'),
            'getQueryReconciliations': S('getQueryReconciliations', '/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReconService.queryRecons'),
            'getOpearationList': S('getOpearationList', '/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReconService.generateRecon'),
            'getSmallTransportReconMisService': S('getSmallTransportReconMisService', '/?cmd=com.xqxc.api.pig.mis.reconciliation.SmallTransportReconMisService.list'),
        },
        reducers: {
            'stateList': R('getStateList', []),
            'tableSource': R('getTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'detail': R('getDetail', {}),
            'QueryReconciliations': R('getQueryReconciliations', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            // 'QueryReconciliations': R('getQueryReconciliations', []),
            'OpearationList': R('getOpearationList', []),
            'SmallTransportReconMisService': R('getSmallTransportReconMisService', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
        }
    })
};
export default createModel(model);